<template>
  <div>
    <v-container fluid>
      <v-row no-gutters>
        <v-col :cols="6">
          <h1 class="headline font-weight-light mb-3">BRANCH</h1>
        </v-col>
        <v-col :cols="6" class="text-right"></v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="editedItem.branch_type"
                  :items="items"
                  item-text="branch_type"
                  item-value="branch_id"
                  menu-props="auto"
                  label="Branch Type"
                  hide-details
                  single-line
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="editedItem.branch_name"
                  label="Branch Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="editedItem.branch_lat"
                  label="Latitude"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="editedItem.branch_lng"
                  label="Longitude"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="editedItem.province_id"
                  :items="provinces"
                  item-text="province_name_en"
                  item-value="province_id"
                  menu-props="auto"
                  label="Province"
                  hide-details
                  single-line
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="editedItem.branch_postalcode"
                  label="Postal Code"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="editedItem.branch_tel"
                  label="Tel"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="editedItem.branch_fax"
                  label="Fax"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6" sm="6">
                <v-textarea
                  outlined
                  name="input-7-4"
                  v-model="editedItem.branch_addr_th"
                  label="Address (TH)"
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-textarea
                  outlined
                  name="input-7-4"
                  v-model="editedItem.branch_addr_en"
                  label="Address (EN)"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  :items="provinces"
                  v-model="branchcover"
                  item-text="province_name_en"
                  item-value="province_id"
                  :value="branchcover.province_id"
                  multiple
                  chips
                  label="Branch Cover"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class="mb-2" @click="newItem()"
          >Create New</v-btn
        >
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="this.data"
        :items-per-page="10"
        :loading="isLoading"
        :search="search"
        loading-text="Loading... Please wait"
      >
        <template v-slot:item.status="{ item }">{{
          item.status == 1 ? "Active" : "Not Active"
        }}</template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)"
            >mdi-square-edit-outline</v-icon
          >
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>
    <div id="snackbar">
      <v-snackbar v-model="snackbar" color="success" right>{{
        text
      }}</v-snackbar>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(["isLoading"]),
    ...mapState(["snackbar"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Branch" : "Edit Branch";
    },
  },
  mounted() {
    this.getAjax();
    this.getAddress();
  },
  data() {
    return {
      search: "",
      data: [],
      provinces: [],
      branchcover: [],
      dialog: false,
      editedIndex: -1,
      editedItem: {
        branch_type: "",
        province_id: "",
        branch_addr_th: "",
        branch_addr_en: "",
        branch_postalcode: "",
        branch_tel: "",
        branch_lat: "",
        branch_lng: "",
        branch_cover: "",
        branch_fax: "",
      },
      defaultItem: {
        branch_type: "",
        province_id: "",
        branch_addr_th: "",
        branch_addr_en: "",
        branch_postalcode: "",
        branch_tel: "",
        branch_lat: "",
        branch_lng: "",
        branch_cover: "",
        branch_fax: "",
      },
      headers: [
        {
          text: "type",
          value: "branch_type",
          class: "text-uppercase blue darken-3 white--text",
        },
        {
          text: "name",
          value: "branch_name",
          class: "text-uppercase blue darken-3 white--text",
        },
        {
          text: "province",
          value: "province_name_en",
          class: "text-uppercase blue darken-3 white--text",
        },
        {
          text: "address",
          value: "branch_addr_th",
          class: "text-uppercase blue darken-3 white--text",
        },
        {
          text: "tel",
          value: "branch_tel",
          class: "text-uppercase blue darken-3 white--text",
        },
        {
          text: "fax",
          value: "branch_fax",
          class: "text-uppercase blue darken-3 white--text",
        },
        {
          text: "Actions",
          value: "action",
          class: "text-uppercase blue darken-3 white--text",
          sortable: false,
        },
      ],
      select: {
        branch_type: "SVC",
        branch_type: "HUB",
        branch_type: "WFH",
        branch_type: "ODM",
        branch_type: "IPG",
        branch_type: "PSG",
      },
      items: [
        { branch_type: "SVC" },
        { branch_type: "HUB" },
        { branch_type: "WFH" },
        { branch_type: "ODM" },
        { branch_type: "IPG" },
        { branch_type: "PSG" },
      ],
      text: "Success, Your work has been saved",
    };
  },
  methods: {
    ...mapMutations(["mutateIsLoading"]),
    ...mapMutations(["mutatesnackbar"]),
    resetEdited() {
      this.editedItem = { ...this.defaultItem };
      this.editedIndex = -1;
    },
    newItem() {
      this.resetEdited();
      this.dialog = true;
    },
    editItem(item) {
      this.editedIndex = item.branch_id;
      item.status = item.status == 1 ? true : false;
      this.editedItem = Object.assign({}, item);
      this.dialog = true;

      this.branchcover = item.branchcover.map((each) => {
        return each.province_id;
      });
    },
    async deleteItem(item) {
      const idx = item.branch_id;
      if (confirm("Are you sure you want to delete this project?")) {
        const url = `${process.env.VUE_APP_ROOT_API}/api/branch`;
        try {
          const { data } = await axios.delete(url + "/" + idx);
        } catch (error) {
          console.log(error);
        }
        this.getAjax();
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.resetEdited();
      }, 300);
    },
    save() {
      this.mutatesnackbar();
      this.editedItem.status = this.editedItem.status === true ? 1 : 0;
      this.editedItem.branch_cover = this.branchcover;

      this.sendAjax(this.editedItem, this.editedIndex);
      this.close();
      if (this.snackbar === true) {
        setTimeout(() => {
          this.mutatesnackbar();
          this.snackbar;
        }, 2000);
      }
    },
    async sendAjax(item, idx) {
      const url = `${process.env.VUE_APP_ROOT_API}/api/branch`;
      if (idx > -1) {
        try {
          const { data } = await axios.put(url + "/" + this.editedIndex, item);
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          const { data } = await axios.post(url, item);
        } catch (error) {
          console.log(error);
        }
      }
      this.getAjax();
    },
    async getAjax() {
      const url = `${process.env.VUE_APP_ROOT_API}/api/branch`;
      try {
        this.mutateIsLoading();
        const { data } = await axios.get(url);
        this.data = data;
        this.mutateIsLoading();
      } catch (error) {
        console.log(error);
      }
    },
    async getAddress() {
      const url = `${process.env.VUE_APP_ROOT_API}/api/provinces`;
      try {
        this.mutateIsLoading();
        const { data } = await axios.get(url);
        this.provinces = data;
        this.mutateIsLoading();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
